export const googleButtonText = 'Kontynuuj z Google';
export const googleButtonDataTest = 'button-external-provider-google';

export const facebookButtonText = 'Kontynuuj z Facebook';
export const facebookButtonDataTest = 'button-external-provider-facebook';

export const appleButtonText = 'Kontynuuj z Apple';
export const appleButtonDataTest = 'button-external-provider-apple';
